document.addEventListener('DOMContentLoaded', function () {
  // Attach one listener per toggle container (works for hidden items too)
  document.querySelectorAll('.hotspots-toggle').forEach(container => {
    container.addEventListener('click', function (e) {
      const link = e.target.closest('button[data-target]');
      if (!link) return;
      
      // Prevent event bubbling
      e.preventDefault();
      e.stopPropagation();

      const target = link.dataset.target;

      // Find all sections globally (since they're separate section blocks)
      const journal = document.querySelector('.journal-section');
      const lifeDesigner = document.querySelector('.life-designer-section');

      if (target === 'journal') {
        console.log('Showing journal, hiding life-designer');
        if (lifeDesigner) {
          lifeDesigner.classList.add('d-none', 'inactive');
          console.log('Life designer classes after hiding:', lifeDesigner.className);
        }
        if (journal) {
          journal.classList.remove('d-none', 'inactive');
          console.log('Journal classes after showing:', journal.className);
        }
      } else if (target === 'life-designer') {
        console.log('Showing life-designer, hiding journal');
        if (journal) {
          journal.classList.add('d-none', 'inactive');
          console.log('Journal classes after hiding:', journal.className);
        }
        if (lifeDesigner) {
          lifeDesigner.classList.remove('d-none', 'inactive');
          console.log('Life designer classes after showing:', lifeDesigner.className);
        }
      }

      // Update active state for ALL toggle buttons (since sections are global)
      document.querySelectorAll('.hotspots-toggle button[data-target]').forEach(button => {
        const isActive = button.dataset.target === target;
        button.classList.toggle('active', isActive);
        button.setAttribute('aria-selected', isActive);
      });
      
    });
  });
});